import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';

import './styles.scss';

const Input = ({label, margin, name, smallContent, small, placeholder, ...rest}) => {
  const inputRef = useRef(null);
  const {registerField , fieldName, defaultValue, error} = useField(name);


  useEffect(() => {
    registerField({
      name:fieldName,
      ref: inputRef.current,
      path:'value'
    })
  },[fieldName, registerField])

  return (
    <div id='input'>
      <div
        className='form-group'
      >
          <label className='label'>
            {label}
          </label>
        <input
          className='form-control'
          defaultValue={defaultValue}
          ref={inputRef}
          {...rest}
        />
        {small && <small className="small">{smallContent}</small>}
        {error && <span className="error"> {error}</span>}
      </div>
    </div>
  );
};

export default Input;
